import type { IContent } from '~/features-shared/content/interfaces/content'
import { ServiceFetchControllerDefault } from '~/features-shared/content-feed/controllers/services-fetch-controller-default'

export class ServiceFetchControllerWithoutTags extends ServiceFetchControllerDefault<IContent> {
  shouldFetchTags() {
    return false
  }
}
